module.exports = __webpack_public_path__ + "img/cart-btn.5ee5d81b.svg";